<div class="p-10 info-container">
  <h2>{{ title }}</h2>
  <p class="m-0">{{ subtitle }}</p>
</div>
<div class="p-10">
  <div *ngIf="chartType === 'bar' || chartType === 'line'">
    <ng-container *ngIf="data$ | async as dataItem; else loadingSpinner">
      <canvas
        *ngIf="dataItem.labels.length && dataItem.datasets.length; else noData"
        baseChart
        [type]="chartType"
        [data]="dataItem"
        [legend]="legend"
        [options]="options"
      >
      </canvas>
    </ng-container>
  </div>

  <div *ngIf="chartType === 'doughnut'">
    <ng-container *ngIf="datasets$ | async as datasetItem; else loadingSpinner">
      <canvas
        *ngIf="datasetItem.labels.length && datasetItem.datasets.length; else noData"
        baseChart
        [type]="chartType"
        [datasets]="datasetItem.datasets"
        [legend]="legend"
        [labels]="datasetItem.labels"
        [options]="options"
      >
      </canvas>
    </ng-container>
  </div>
  <ng-template #loadingSpinner>
    <mat-spinner></mat-spinner>
  </ng-template>
  <ng-template #noData>
    <p>No Data</p>
  </ng-template>
</div>
